import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import {
  CK_ACCESS_DATA_ROLE,
  CK_ACCESS_TOKEN,
  CK_SHARED_TOKEN,
} from "@constant/constant";
import { APIEndpointWeb, webapi } from "@client/web";
const { Text } = Typography;

const NewPasswordLogin: React.FC = (): JSX.Element => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [WindowResize, setWindowResize] = useState(Number);
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
  ]);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const getchangepassword = async () => {
    setLoading(true);
    try {
      const datachangepassword = {
        old_password: oldPassword,
        new_password: newPassword,
      };
      var { data } = await webapi.post(
        `${APIEndpointWeb.ChangePassword}`,
        datachangepassword,
        {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` },
        }
      );
      Modal.success({
        title: "แก้ไขรหัสผ่านสำเร็จ",
      });
      history.replace("/login");
    } catch (error) {
      console.log(error);
      Modal.error({
        title: "ส่งข้อมูลไม่สำเร็จ กรุณาตรวจสอบใหม่อีกครั้ง",
      });
      setLoading(false);
    }
  };
  return (

    <Spin tip="กำลังโหลด..." spinning={loading}>
      <div
        style={{
          height: "60vh",
          display: "flex",
          // paddingLeft: "200px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form>
          <Row >
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} >
              <Row style={{ justifyContent: 'center', display: 'flex' }}>
                <Text
                  style={{
                    fontSize: "36px",
                    fontWeight: "bold",
                    color: "#2E6872",
                  }}
                >
                  ตั้งค่ารหัสผ่านใหม่
                </Text>
              </Row>
              <Row>
                <Text style={{ fontSize: "18px", color: "#2E6872", justifyContent: 'center', display: 'flex' }}>
                  กรุณากรอกข้อมูลและระบุรหัสผ่านใหม่ที่ต้องการ
                </Text>
              </Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="mt-3">
                <Row>
                  <Typography.Text
                    style={{ color: "#2E6872", fontSize: "16px" }}
                  >
                    รหัสผ่านเดิม
                  </Typography.Text>
                  <Typography.Text
                    style={{ color: "#E32A30", fontSize: "16px" }}
                  >
                    *
                  </Typography.Text>
                </Row>
                <Input.Password
                  style={{ height: "40px" }}
                  className="mt-2"
                  placeholder="กรุณากรอกรหัสผ่านเดิม"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                    setOldPassword(e.target.value);
                  }}
                  value={oldPassword}
                />
              </Col>
              <Row className="mt-3">
                <Typography.Text
                  style={{ color: "#2E6872", fontSize: "16px" }}
                >
                  รหัสผ่านใหม่
                </Typography.Text>
                <Typography.Text
                  style={{ color: "#E32A30", fontSize: "16px" }}
                >
                  *
                </Typography.Text>
              </Row>
              <Input.Password
                className="mt-2"
                style={{
                  height: "40px",
                }}
                type="password"
                placeholder="กรุณากรอกรหัสผ่านใหม่"
                onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                  let new_pass = e.target.value;
                  setNewPassword(new_pass);
                  var lowerCase = /[a-z]/g;
                  var upperCase = /[A-Z]/g;
                  var numbers = /[0-9]/g;
                  if (!new_pass.match(lowerCase)) {
                    setError(true);
                  } else if (!new_pass.match(upperCase)) {
                    setError(true);
                  } else if (!new_pass.match(numbers)) {
                    setError(true);
                  } else if (new_pass.length < 8) {
                    setError(true);
                  } else {
                    setError(false);
                  }
                }}
                value={newPassword}
              />
              <Row>
                <Text>
                  {error ? (
                    <div>
                      <Row>
                        <Text
                          className="font-description"
                          style={{ color: "#F30101", fontSize: "12px" }}
                        >
                          - รหัสผ่านของคุณต้องมีความ 8 ตัวอักษร
                        </Text>
                      </Row>
                      <Row>
                        <Text
                          className="font-description"
                          style={{ color: "#F30101", fontSize: "12px" }}
                        >
                          - ควรมีทั้งตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข
                        </Text>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}
                </Text>
              </Row>
              <div className="mt-5" style={{ justifyContent: 'center', display: 'flex' }}>
                <Button
                  type="primary"
                  block
                  size="large"
                  onClick={(): void => {
                    if (oldPassword !== newPassword) {
                      getchangepassword();
                    } else {
                      Modal.error({
                        title: "รหัสผ่านตรงกัน กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
                      });
                    }
                  }}
                  style={{ width: "300px", borderRadius: "20px" }}
                  disabled={oldPassword === "" || newPassword === ""}
                >
                  ยืนยัน
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Spin >
  );
};
export default NewPasswordLogin;
